import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import truncate from "truncate";
import "../styles.scss";
import AppHeader from "../../../../../components/AppHeader/AppHeader";
import Footer from "../../../../../components/Footer/Footer";
import FreshdeskHelpWidget from "../../../../../components/FreshdeskHelpWidget/FreshdeskHelpWidget";
import ResourceNotFoundError from "../../../../../errors/resourceNotFoundError";
import spaPagePropTypes from "../../../../../types/SpaPage/SpaPagePropTypes";
import PageHead from "../../../PageHead";
import PageBreadcrumbs from "../components/PageBreadcrumbs/PageBreadcrumbs";
import RelatedQuestions from "./RelatedQuestions";

const propTypes = {
  ...spaPagePropTypes,
};

const HelpSinglePostPage = ({
  analytics,
  currentUrl,
  lang,
  pageData: faq,
  routerLoading,
  t,
  translationUrls,
  url,
  user,
}) => {
  if (!faq.post) {
    throw new ResourceNotFoundError({ resource: "FAQPost" });
  }

  const { pathname } = useLocation();

  useEffect(() => {
    if (!routerLoading) {
      window.scrollTo(0, 0);
    }
  }, [pathname, routerLoading]);

  const postTitle = faq.post.title;
  const postBody = faq.post.description;

  const title = `${postTitle} - ${t("spages.help.documentTitle")}`;
  const description = truncate(faq.post.description_text, 250, {
    ellipsis: "...",
  });
  const headProps = {
    title,
    description,
    translationUrls,
    canonicalUrl: url("helpSinglePost", {
      postId: faq.post.id,
    }),
  };

  const links = [
    { title: t("spages.help.breadcrumbBase.title"), href: url("help") },
    {
      title: faq.category.name,
      href: url("helpCategory", {
        categoryId: faq.category.id,
      }),
    },
    {
      title: faq.subcategory.name,
      href: url("helpSubCategory", {
        subcategoryId: faq.subcategory.id,
      }),
    },
  ];

  return (
    <div className="HelpSinglePostPage">
      <PageHead {...headProps} />
      <AppHeader
        currentUrl={currentUrl}
        lang={lang}
        t={t}
        theme="white"
        translationUrls={translationUrls}
        user={user}
        analyticsEvent={analytics?.event}
      />
      <div className="HelpSinglePost-container">
        <section className="HelpSinglePost pageSection">
          <div className="pageSection-inner">
            <div className="HelpSinglePost-post">
              <PageBreadcrumbs
                lang={lang}
                links={links}
                currentLink={{ title: postTitle }}
              />
              <h1 className="heading-large heading-large--bold">{postTitle}</h1>
              <div
                className="HelpSinglePost-postBody"
                // eslint-disable-next-line
                dangerouslySetInnerHTML={{ __html: postBody }}
              />
              {!!faq.post.related_posts &&
                faq.post.related_posts.length > 0 && (
                  <RelatedQuestions
                    t={t}
                    relatedPosts={faq.post.related_posts}
                    lang={lang}
                    url={url}
                  />
                )}
            </div>
          </div>
        </section>

        <Footer url={url} user={user} />
      </div>

      <FreshdeskHelpWidget />
    </div>
  );
};

HelpSinglePostPage.propTypes = propTypes;

export default HelpSinglePostPage;
